export default "__VITE_ASSET__djqyoA7___"